import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import LogContainer from './LogContainer'


const LogRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><LogContainer></LogContainer></Provider>
}

LogRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default LogRoot
